import ICustomerService from './ICustomerService'
import {Client} from '@apps/Shared/Services/Axios'
import {AxiosResponse} from 'axios'
import {ENDPOINT} from '../Axios/Api'
import {
    AddCustomerPostBody,
    ContactCustomerPostBody
} from "@apps/Shared/Services/Customer/interfaces";
import {clearServerMessage, renderServerMessage} from "@apps/Shared/Utils/ServerMessage";
import i18n from "@apps/Shared/translation/i18n";
import {CustomerItem} from "@apps/Shared/Context/CustomerContext";

class CustomerService implements ICustomerService {
    async GetActiveCustomer() {
        let res: AxiosResponse;

        try {
            res = await Client('get', ENDPOINT.Customer.GetActiveCustomer());
            clearServerMessage();
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async SetActiveCustomer(activeCustomer: CustomerItem) {
        let res: AxiosResponse;

        try {
            res = await Client('post', ENDPOINT.Customer.SetActiveCustomer(), activeCustomer);
            clearServerMessage()
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'))
            return error.response;
        }

        return res;
    }


    async GetAllCustomers() {
        let res: AxiosResponse;

        try {
            res = await Client('get', ENDPOINT.UserProfile.Companies());
            clearServerMessage()
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'))
            return error.response;
        }

        return res;
    }

    async AddCustomer(postBody: AddCustomerPostBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', ENDPOINT.UserProfile.AddCustomer(), postBody);
            clearServerMessage();
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }

    async ContactCustomer(postBody: ContactCustomerPostBody) {
        let res: AxiosResponse;

        try {
            res = await Client('post', ENDPOINT.UserProfile.ContactCustomer(), postBody);
            clearServerMessage();
        } catch (error: any) {
            console.error("Error:", error);
            renderServerMessage('error', i18n.t('error.disruptions'));
            return error.response;
        }

        return res;
    }
}

export default new CustomerService();